import { useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Activity } from '@robocorp/robocloud-internal-cds-sdk';
import { Link, Table } from '@robocorp/components';
import { useParams } from '~/hooks';
import { CellRunDetails } from '~/components';

interface Props {
  step?: Activity;
  processId: string;
  processRunId: string | null;
  processRunNo?: number;
  activityId?: string;
  activityRunId: string | null;
  queueTs?: string;
}

export const WorkDataTableStepRunCell: React.FC<Props> = ({
  step,
  processId,
  processRunId,
  processRunNo,
  activityId,
  activityRunId,
}) => {
  const { organizationShortName, workspaceShortName } = useParams<
    'organizationShortName' | 'workspaceShortName'
  >();

  const detailsLink = useMemo(
    () =>
      `/${organizationShortName}/${workspaceShortName}/processes/${processId}/runs/${processRunId}/stepRuns/${activityRunId}`,
    [organizationShortName, workspaceShortName, processId, processRunId, activityRunId],
  );

  if (!processRunId || !processRunNo || !activityId || !activityRunId || !step?.name)
    return <Table.Cell>-</Table.Cell>;

  return (
    <Table.Cell maxWidth={400} controls>
      <Link as={RouterLink} to={detailsLink} target="_blank">
        <CellRunDetails text={step.name} subText={step.template?.name} number={step.order_number} />
      </Link>
    </Table.Cell>
  );
};
